class TextExpandable extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[aria-expanded]');
    this.content = this.querySelector('[data-expandable-content]');

    if (!this.button || !this.content) return;

    // Store the lines value for collapse functionality
    this.lines = this.content.dataset.lines;

    this.button.addEventListener('click', this.toggle.bind(this));
    this.checkIfExpandable();
  }

  /**
   * Check if content actually needs expansion
   * If content fits within line clamp, hide the button
   */
  checkIfExpandable() {
    const contentHeight = this.content.scrollHeight;
    const visibleHeight = this.content.clientHeight;

    if (contentHeight <= visibleHeight) {
      this.button.style.display = 'none';
    }
  }

  /**
   * Expand the text content
   */
  expand() {
    this.button.setAttribute('aria-expanded', 'true');
    this.content.removeAttribute('data-lines');
    this.updateButtonText();
  }

  /**
   * Collapse the text content
   */
  collapse() {
    this.button.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('data-lines', this.lines);
    this.updateButtonText();
  }

  /**
   * Toggle between expanded and collapsed states
   */
  toggle() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.collapse() : this.expand();
  }

  /**
   * Update button text based on state
   */
  updateButtonText() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    const readMoreText = this.button.dataset.readMore;
    const readLessText = this.button.dataset.readLess;

    this.button.textContent = isExpanded ? readLessText : readMoreText;
  }
}

customElements.define('text-expandable', TextExpandable);
